module.exports = __webpack_public_path__ + "static/media/reversePyramidFilter_Inactive.c14a11b9.svg";